import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import Frame from '../Onboarding/Frame';
import { LoadingBar } from '../../components/util/LoadingBar';

import PlanIntro from '../Onboarding/PlanIntro'; //Move to Microtools folder

import InvestmentFees from './InvestmentFees';
import InvestmentFeesAnalysis from './InvestmentFeesAnalysis';
import MaxTaxAdvantagedSavings from './MaxTaxAdvantagedSavings';
import GuaranteedIncome from './GuaranteedIncome';
import FinancialShock from './FinancialShock';
import SocialSecurity from './SocialSecurity';
import ReviewWithHarbor from '../ReviewWithHarbor';

import ContentPage from './ContentPage';

import { fetchDashboard } from '../../actions/dashboardActions';
import { fetchContentPages } from '../../actions/contentPagesActions';
import { fetchPeople } from '../../actions/peopleActions';
import { fetchOnboarding } from '../../actions/onboardingActions';

import { wlPath, wlVar } from '../../helpers/whitelabel';

export class ActionPlan extends Component {
  componentWillMount() {
    if (!this.props.dashboard.fetched || !this.props.dashboard.data.primary_person_id) {
      this.props.dispatch(fetchDashboard());
    }
    if (!this.props.people) {
      this.props.dispatch(fetchPeople());
    }
    if (!this.props.onboarding.fetched) this.props.dispatch(fetchOnboarding());
    if (!this.props.contentPages) {
      this.props.dispatch(fetchContentPages());
    }
  }

  render() {
    const { dashboard, history, match, user, contentPages, onboarding } = this.props;

    if (!user || !dashboard.fetched || !contentPages || !onboarding.fetched) {
      return <LoadingBar />;
    }

    if (!contentPages.length) {
      history.push(wlPath('/'));
    }

    if (!dashboard.data.primary_person_id) {
      return <LoadingBar />;
    }

    return (
      <Frame match={match}>
        <Switch>
          <Route exact path={match.url} component={PlanIntro} />

          <Route exact path={match.url + '/social-security'} component={SocialSecurity} />

          <Route exact path={match.url + '/investment-fees'} component={InvestmentFees} />
          <Route exact path={match.url + '/investment-fees/analysis'} component={InvestmentFeesAnalysis} />

          <Route exact path={match.url + '/financial-shock'} component={FinancialShock} />

          <Route exact path={match.url + '/guaranteed-income'} component={GuaranteedIncome} />
          <Route exact path={match.url + '/maximize-tax-advantaged'} component={MaxTaxAdvantagedSavings} />

          <Route path={match.url + '/review-plan'} component={ReviewWithHarbor} />
          {contentPages.map(x => (
            <Route key={x.url_slug} path={match.url + '/' + x.url_slug} component={ContentPage} />
          ))}
        </Switch>
      </Frame>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
    dashboard: state.modules.dashboard,
    people: state.modules.people,
    onboarding: state.onboarding,
    contentPages: state.contentPages.data,
  };
}

export default connect(mapStateToProps)(ActionPlan);
